package com.vizio.redwolf.auth.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
class HasPinRequestBody(
    @SerialName("accessToken") val accessToken: String
)

@Serializable
class CreatePinRequestBody(
    @SerialName("pin") val pin: String,
    @SerialName("accessToken") val accessToken: String
)

@Serializable
class ValidatePinRequestBody(
    @SerialName("pin") val pin: String,
    @SerialName("accessToken") val accessToken: String
)

@Serializable
class UpdatePinRequestBody(
    @SerialName("pin") val pin: String,
    @SerialName("accessToken") val accessToken: String
)

@Serializable
class DeletePinRequestBody(
    @SerialName("accessToken") val accessToken: String
)
